import {EmbedType} from "../../../../core/gd/const/embed/embed-type";

export type NavigationMenuInlineAddParams = {
    templateId?     : ID
    embedType?      : EmbedType

    isEmpty?        : boolean // for folders
}

export enum NavigationMenuInlineAddType {
    FOLDER      = 'folder',
    PAGE        = 'page',
    WHITEBOARD  = 'whiteboard',
    GROUP       = 'group',
    LINK        = 'link',
    EMBED       = 'embed',
    GOALS       = 'goal',
    FILES       = 'files',
    MEETINGS    = 'meetings',
    EXPENSES    = 'expenses',
    CHATS       = 'chats',
    TASK_LIST   = 'task-list',
    TASK_BOARD  = 'task-board',
    TODOS       = 'todos'
}
